
import React, {useState, useEffect} from 'react';
import "./styles.css";
import {formatNumberThousand} from './../../func/functions';
import {useDispatch} from 'react-redux';
import {requestVisit} from './../../actions/initiativeActions';

function Menu(){

    const dispatch = useDispatch();
    const [requestVisitflag, svrequestVisitflag] = useState(true);
    const [visitCount, svvisitCount] = useState("Desconocido");

    const cbRequestVisit = (data) => {
        svvisitCount(data.visit);
    }

    useEffect(() => {
        if(requestVisitflag === true){
            svrequestVisitflag(false);
            dispatch(requestVisit(cbRequestVisit));
        }

    }, [requestVisitflag, dispatch]);

    return(
        <div className="row m-0 align-items-center justify-content-between menu-header w-100">
            {/*<div style={{fontWeight:"bold", fontSize:16, textAlign:"center", padding:10}}>DIÁLOGOS VALLECAUCANOS PORQUE EL VALLE SOMOS TODOS</div>*/}
            <div className="col-12 col-md-4 d-flex justify-content-center p-2">
                <a className="bt-1" href="https://www.valledelcauca.gov.co/" style={{width:"auto"}}>Inicio Gobernación</a>
            </div>
            <div className="col-12 col-md-4 d-flex justify-content-center p-2">
            <div style={{color:"#000000", fontWeight:"bold",fontSize:"18px"}}>Plan de Desarrollo Departamental 2024 - 2027</div>
                {/* {<img alt={""} src={require('./../../assets/img/header.png')} style={{width:310, objectFit:"cover"}}/>} */}
            </div>
            <div className="col-12 col-md-4 d-flex justify-content-center p-2">
                <div style={{color:"#0056b3", fontWeight:"bold"}}>{`Visitas: ${formatNumberThousand(visitCount)}`}</div>
            </div>
        </div>
    );

}

export default Menu;
  